<div class="c-page-incomingrequest">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'IncomingRequestPortal.home'| translate}} </a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp;-<span> {{'IncomingRequestPortal.location' | translate}} </span></li>
                    </ol>
                </nav>
                <h2 class="o-title"> {{'IncomingRequestPortal.title' | translate}}</h2>

            </div>
        </div>
    </div>
    <div class="content-filter">
        <div class="content-filter__group">
            <span></span>
            <input (keyup.enter)="getEmployeeListFilter()" style="background-color: white;" min="0" [(ngModel)]="requestF" class="o-form__input" type="number" placeholder="{{'IncomingRequestPortal.placeholderNumber'| translate}}" numbersOnly>
            <div *ngIf="isNegative(requestF)" style="width:100%; background-color: #F2F0E9">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'IncomingRequestPortal.noNegativeNumber'| translate}}</mat-error></h5></span>
            </div>
        </div>



        <div class="content-filter__group">
            <span></span>
            <select name="typeSelect" (change)="getEmployeeListFilter()" [(ngModel)]="typeF" class="o-form__select" required> 
                    <option ngValue='' >{{'IncomingRequestPortal.filterType'| translate}}</option>
                    <option [ngValue]='type.id' *ngFor="let type of types">
                        <strong *ngIf="type.id == 1"> {{'IncomingRequestPortal.employee' | translate }} </strong>
                        <strong *ngIf="type.id == 2"> {{'IncomingRequestPortal.contractor' | translate }} </strong>
                        <strong *ngIf="type.id == 3"> {{'IncomingRequestPortal.visitors' | translate }} </strong>
                        <strong *ngIf="type.id == 4"> {{'IncomingRequestPortal.exception' | translate }} </strong>    
                    </option>
                    <!-- <option ngValue="false"  >{{'table-columns.replacement'| translate}}</option>  {{'table-columns.new'| translate}}-->
                  </select>
        </div>

        <div class="content-filter__group">
            <span></span>
            <select name="statusSelect" (change)="getEmployeeListFilter()" [(ngModel)]="statusF" class="o-form__select" required> 
                    <option ngValue=''>{{'IncomingRequestPortal.filterStatus'| translate}}</option>
                    <option  *ngFor="let status of statusOptions" [ngValue]="status.id"> 
                        <p *ngIf="status.id==1">{{'IncomingRequestPortal.statusPending'| translate}}</p>
                        <p *ngIf="status.id==5">{{'IncomingRequestPortal.statusPendingSarApprover'| translate}}</p>
                        <p *ngIf="status.id==6">{{'IncomingRequestPortal.statusPendingFacility'| translate}}</p>
                        
                        <p *ngIf="status.id==2">{{'IncomingRequestPortal.statusApproved'| translate}}</p>   
                        <p *ngIf="status.id==7">{{'IncomingRequestPortal.statusApprovedSarApprover'| translate}}</p>    
                        <p *ngIf="status.id==8">{{'IncomingRequestPortal.statusApprovedFacility'| translate}}</p>    
    
                        <p *ngIf="status.id==3">{{'IncomingRequestPortal.statusReject'| translate}}</p>    
                        <p *ngIf="status.id==9">{{'IncomingRequestPortal.statusRejectSarApprover'| translate}}</p>    
                        <p *ngIf="status.id==10">{{'IncomingRequestPortal.statusRejectFacility'| translate}}</p>
                            
                        <p *ngIf="status.id==4">{{'IncomingRequestPortal.statusDelegate'| translate}}</p>    
                        <p *ngIf="status.id==11">{{'IncomingRequestPortal.statusClosed'| translate}}</p>       
                    </option>
                
                  </select>
        </div>
        <div class="content-filter__group">
            <span></span>
            <input  (input)="searchPerson($event)" style="background-color: white;" [(ngModel)]="searchPeople" class="o-form__select" type="text" placeholder="{{'IncomingRequestPortal.placeholderName'| translate}}" [matAutocomplete]="autoPersonBHP">
            <mat-autocomplete #autoPersonBHP="matAutocomplete">
                <mat-option *ngFor="let option of peoples" [value]="option.fullName">
                    <div *ngIf="personFound" (click)="addpeopleMdmidFilterValue(option.mdmid)" >
                        <label mat-raised-button matTooltip="{{option.email}}" 
                        matTooltipPosition='right' matTooltipClass="primary-tooltip"
                        aria-label="Button that displays a tooltip in various positions">
                        {{option.fullName}}</label>

                    </div>
                    <div *ngIf="personNotFound">
                        {{'IncomingRequestPortal.notFound'| translate}}
                    </div>

                </mat-option>

            </mat-autocomplete>
        </div>

        <div class="content-filter__group">
            <div slign="center">
                <mat-form-field>
                    <mat-label>{{'IncomingRequestPortal.filterDateStart'| translate}}</mat-label>
                    <input matInput #resultPickerModel="ngModel" [max]="maxDate" [matDatepicker]="picker" [(ngModel)]="dateSelectStart" value="date">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="resultPickerModel.hasError('matDatepickerParse')">
                        "{{resultPickerModel.getError('matDatepickerParse').text}}" {{'IncomingRequestPortal.validDate'| translate}}
                    </mat-error>
                    <mat-error *ngIf="resultPickerModel.hasError('matDatepickerMax')">{{'IncomingRequestPortal.minDate'| translate}}</mat-error>
                </mat-form-field>

                <div slign="center">
                    <mat-form-field>
                        <mat-label>{{'IncomingRequestPortal.filterDateEnd'| translate}}</mat-label>
                        <input matInput #resultPickerModel2="ngModel" [min]="dateSelectStart" [max]="maxDate" [matDatepicker]="picker2" [(ngModel)]="dateSelectEnd" value="date">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                        <mat-error *ngIf="resultPickerModel2.hasError('matDatepickerParse')">
                            "{{resultPickerModel2.getError('matDatepickerParse').text}}" {{'IncomingRequestPortal.validDate'| translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
        </div>
    </div>

    <div class="container u-pb30">
        <div class="row">
            <div class="col-md-12">
                <div class="c-search">
                    <tr>
                        <td>
                            <p style="padding: 10px;">
                                <span class="table__mobile"> </span>
                                <button class="btn btn--primary open_modal" (click)="clearFilter()" (click)="resultPickerModel.reset()" (click)="resultPickerModel2.reset()" mat-raised-button>{{'IncomingRequestPortal.btnClearFilter'| translate}}</button>
                            </p>
                        </td>
                        <td>
                            <p>
                                <span class="table__mobile"> </span>
                                <button class="btn btn--primary open_modal" [disabled]="isNegative(requestF)" (click)="getEmployeeListFilter()" mat-raised-button>{{'IncomingRequestPortal.btnApplyFilter'| translate}}</button>
                            </p>
                        </td>
                    </tr>
                </div>


                <table class="table table-bordered table-striped table-condensed">
                    <thead>
                        <tr>
                            <th>
                                <p><a (click)="orderby('requestNumber', requestDesc)"><span >{{'IncomingRequestPortal.colReqNumber' | translate}}</span>
                                     <i *ngIf="!requestDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                    <i *ngIf="requestDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i> 
                                    </a>
                                </p>
                            </th>
                            <th>
                                <p> <a (click)="orderby('type',typeDesc )"><span>{{'IncomingRequestPortal.colType' | translate}}</span>

                                    <i *ngIf="!typeDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                    <i *ngIf="typeDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>  
                                    </a>
                                </p>

                            </th>
                            <th>
                                <p><a (click)="orderby('status', statusDesc)"><span >{{'IncomingRequestPortal.colStatus' | translate}}</span>
                                    <i *ngIf="!statusDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                    <i *ngIf="statusDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>
                                    </a>
                                </p>
                            </th>
                            <th>
                                <p><a (click)="orderby('requesterId', requestorDesc)"><span > {{'IncomingRequestPortal.colRequestor' | translate}}</span>
                                    <i *ngIf="!requestorDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                    <i *ngIf="requestorDesc" style="cursor: pointer; transform: rotate(90deg);;" class="icon icon-arrow "></i>
                                    </a>
                                </p>
                            </th>

                            <th>
                                <p><a (click)="orderby('requestDate', requestDateDesc)"><span > {{'IncomingRequestPortal.colReqDate' | translate}}</span>
                                    <i *ngIf="!requestDateDesc" style="cursor: pointer;" class="icon icon-arrow icon-arrow-down"></i> 
                                    <i *ngIf="requestDateDesc" style="cursor: pointer; transform: rotate(90deg);" class="icon icon-arrow "></i>
                                    </a>
                                </p>
                            </th>
                            <th>
                                <p><a><span > {{'IncomingRequestPortal.colDetails' | translate}}</span>
                                   
                                    </a>
                                </p>
                            </th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let item of SeeItems">
                            <td style="text-align: center;">
                                <p>
                                    <strong>
                                        {{item.requestNumber}}
                                    </strong>
                                </p>
                            </td>
                            <td class="table__title-row">
                                <p>
                                    <strong *ngIf="item.type.Id == 1"> {{'IncomingRequestPortal.employee' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 2"> {{'IncomingRequestPortal.contractor' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 3"> {{'IncomingRequestPortal.visitors' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 4"> {{'IncomingRequestPortal.exception' | translate }} </strong>
                                    <!-- <strong *ngIf="item.type==true"> {{'table-columns.new'| translate}} </strong>
                                    <strong *ngIf="item.type==false"> {{'table-columns.replacement'| translate}} </strong> -->
                                </p>
                            </td>

                            <td>

                                <i *ngIf="item.status.Id==1 || item.status.Id==5 || item.status.Id==6" class="icon icon-more"></i>
                                <i *ngIf="item.status.Id==11|| item.status.Id==3 || item.status.Id==9 || item.status.Id==10" class="icon icon-close"></i>
                                <i *ngIf="item.status.Id==2 || item.status.Id==7 || item.status.Id==8" class="icon icon-check"></i>
                                <i *ngIf="item.status.Id==4" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i>

                                <span *ngIf="item.status.Id==1">{{'IncomingRequestPortal.statusPending'| translate}} </span>
                                <span *ngIf="item.status.Id==5"> {{'IncomingRequestPortal.statusPendingSarApprover' | translate}} </span>
                                <span *ngIf="item.status.Id==6"> {{'IncomingRequestPortal.statusPendingFacility' | translate}} </span>

                                <span *ngIf="item.status.Id==3">{{'IncomingRequestPortal.statusReject'| translate}} </span>
                                <span *ngIf="item.status.Id==9">{{'IncomingRequestPortal.statusRejectSarApprover'| translate}}</span>
                                <span *ngIf="item.status.Id==10">{{'IncomingRequestPortal.statusRejectFacility'| translate}} </span>

                                <span *ngIf="item.status.Id==2">{{'IncomingRequestPortal.statusApproved'| translate}} </span>
                                <span *ngIf="item.status.Id==7">{{'IncomingRequestPortal.statusApprovedSarApprover'| translate}} </span>
                                <span *ngIf="item.status.Id==8"> {{'IncomingRequestPortal.statusApprovedFacility'| translate}}  </span>

                                <span *ngIf="item.status.Id==4">&nbsp; {{'IncomingRequestPortal.statusDelegate' | translate}} </span>
                                <span *ngIf="item.status.Id==11"> {{'IncomingRequestPortal.statusTerminated' | translate}}  </span>


                            </td>

                            <td style="text-align: center;">
                                <p> <strong> {{ item.requestorName }}  </strong> </p>
                            </td>
                            <td>
                                <p> <strong> {{ item.createdAt | date: 'dd/MM/yyyy': 'dd/MM/yyyy'  }}  </strong> </p>
                            </td>

                            <td>
                                <div align="center">
                                    <p>
                                        <span class="table__mobile">{{'IncomingRequestPortal.colDetails' | translate}}: </span>
                                        <a [routerLink]="['/incoming-access-requests/details/', item.requestNumber ]">
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="" title="{{'IncomingRequestPortal.msgSeeDetails'| translate}}">
                                        </a>
                                    </p>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>
            <div class="col-md-12">
                <hr class="big">
                <div class="row pagination-main">
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-6">
                        <ul class="pagination">

                            <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" (page)="handlePage($event)" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>